

<router-outlet />

